import {
  API_ROOT,
  dispatchGetJSONAsync,
  dispatchPostJSONAsync,
  completeJSONAsync,
} from './BaseApi';
import appdata from '../Services/appdata';

const ApiProjectedFinancialPerformance = () => {
  const getSummary = async (selectedYears, DimDateKeys) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');

    let _selectedYears = selectedYears.slice();
    const allIndex = _selectedYears.indexOf('All');
    if (allIndex > -1) _selectedYears.splice(allIndex, 1);
    const filter = { FYs: _selectedYears, DimDateKeys: DimDateKeys };

    queryParams += '?filter=' + JSON.stringify(filter);

    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/projectedFinancialPerformance/${company_id}/${company_org_id}/summary${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  const getDetail = async (DimDateKeys, defaultDimDate) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');
    
    let filter = { DimDateKeys: DimDateKeys };
    queryParams += '?filter=' + JSON.stringify(filter);
    let task = await dispatchPostJSONAsync(
      `${API_ROOT}/projectedFinancialPerformance/${company_id}/${company_org_id}/detail${queryParams}`,
      {
        defaultDimDate: defaultDimDate,
      },
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  return {
    getSummary,
    getDetail,
  };
};

export default ApiProjectedFinancialPerformance();
